<template>
  <footer class="site-footer">
    <div class="wrapper">
      <div class="footer-link">
        <ul>
          <li>
            <a id="privacyLink" href="#">
              {{ constants.PRIVACY_POLICY_LINK }}
            </a>
          </li>
          <li>
            <a id="termsLink" href="#">
              {{ constants.TERMS_CONDITIONS_LINK }}
            </a>
          </li>
        </ul>
      </div>
      <div class="footer-text">
        {{ constants.COPY_RIGHT_TEXT }}
      </div>
      <div class="clear"></div>
    </div>
  </footer>
</template>
<script lang="ts">
import constants from "@/utils/en-US-Employee.json";

export default {
  name: "Footer",
  data() {
    return {
      constants,
    };
  },
};
</script>
